import React, { useState, useEffect, useRef } from 'react'
import _ from 'lodash/fp'

const withWidth = Component => ({ ...props }) => {
  const ref = useRef(null)
  const [width, setWidth] = useState(0)
  useEffect(() => {
    const updateComponentWidth = () => {
      setWidth(_.result('current.getBoundingClientRect.width', ref))
    }

    window.addEventListener('resize', updateComponentWidth)

    // call on mount
    updateComponentWidth()
    return () => { window.removeEventListener('resize', updateComponentWidth) }
  }, [ref.current])
  return <div ref={ref}><Component width={width} {...props} /></div>
}

export default withWidth
